import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { IframeAuthenticationRoutingModule } from './iframe-authentication-routing.module';
import { GeotabLoginComponent } from './pages/geotab-login/geotab-login.component';
import { IframeLoginComponent } from './pages/iframe-login/iframe-login.component';
import { IframeImplicitLoginComponent } from './pages/iframe-implicit-login/iframe-implicit-login.component';
import { UnauthorizedErrorPageComponent } from './pages/unauthorized-error-page/unauthorized-error-page.component';
import { RsaSsoLoginComponent } from './pages/rsa-sso-login/rsa-sso-login.component';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { Auth0SsoLoginComponent } from './pages/auth0-sso-login/auth0-sso-login.component';
import { TN3600SsoLoginComponent } from './pages/tn360-sso-login/tn360-sso-login.component';
import { OAuthLoginComponent } from './pages/oauth-login/oauth-login.component';

import { MatButtonModule } from '@angular/material/button';
import { AuthenticationModule } from '@app-auth/authentication.module';
import { GeotabEulaComponent } from './pages/geotab-eula/geotab-eula.component';

@NgModule({
  imports: [CommonModule, MatButtonModule, IframeAuthenticationRoutingModule, MatProgressSpinnerModule, AuthenticationModule],
  declarations: [
    IframeLoginComponent,
    IframeImplicitLoginComponent,
    UnauthorizedErrorPageComponent,
    RsaSsoLoginComponent,
    GeotabLoginComponent,
    PageNotFoundComponent,
    Auth0SsoLoginComponent,
    TN3600SsoLoginComponent,
    OAuthLoginComponent,
    GeotabEulaComponent,
  ],
})
export class IframeAuthenticationModule {}
